import { createFileRoute, redirect } from '@tanstack/react-router'
import { LandingPageEditorPage } from '@/pages/LandingPages/LandingPageEditorPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/landing-pages_/$pageId')({
  component: RouteComponent,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/landing-pages')) {
      throw redirect({ to: '/' })
    }
  },
})

function RouteComponent() {
  const { pageId } = Route.useParams()
  return <LandingPageEditorPage pageId={pageId} />
}
